import { get } from 'lodash-es';
import { createSelector } from 'reselect';

export const selectApplicationId = createSelector(
  (state) => get(state, 'eligibility.responseData.data.applicationId', ''),
  (applicationId) => applicationId
);

export const selectAccountType = createSelector(
  (state) =>
    get(
      state,
      'updateSelectedAccountReducer.selectedProducts[0].productCodeDescription',
      ''
    ),
  (accountType) => accountType
);

export const selectProductDetails = createSelector(
  (state) => get(state, 'productSelection', {}),
  (productSelection) => productSelection
);

export const selectSessionId = createSelector(
  (state) => get(state, 'sessionId', 'ERROR_CREATING_SESSION_ID'),
  (sessionId) => sessionId
);

export const selectQueryParams = createSelector(
  (state) => get(state, 'queryParams'),
  (queryParams) => (queryParams ? queryParams : null)
);

export const selectDspSessionToken = createSelector(
  (state) => get(state, 'dspSession', ''),
  (dspSession) => dspSession
);

export const selectProductCode = createSelector(
  (state) => get(state, 'productSelection.productCode', ''),
  (productCode) => productCode
);

export const selectSbsoluteSessionTimoutFlag = createSelector(
  (state) => get(state, 'sessionTimeout.absoluteSessionTimoutFlag', false),
  (absoluteSessionTimoutFlag) => absoluteSessionTimoutFlag
);
